<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { checkInjectAssistantJs } from '@/helpers/integrations'
import CardsSprite from '@/assets/cards/cards-sprite.svg?component'
import RotateScreen from '@/components/RotateScreen.vue'
import { AnalysisPopup } from '@/components/modals/AnalysisPopup'
import SeatPlayerAlreadyModal from '@/components/modals/SeatPlayerAlredyModal.vue'
import AttentionModal from '@/components/modals/AttentionModal.vue'
import { useVersionCheck } from './composables/useVersionCheck'

onMounted(async () => {
  await checkInjectAssistantJs()
})

useVersionCheck()
</script>

<template>
  <main>
    <router-view />
    <rotate-screen />
  </main>

  <AnalysisPopup />
  <SeatPlayerAlreadyModal />
  <AttentionModal />
  <CardsSprite v-once class="hidden" aria-hidden="true" />
</template>
